export default __webpack_public_path__ + "static/media/empty-tasks.e157cef4.svg";